import classNames from 'classnames/bind';
import styles from './SelectFranchise.module.scss';
import { AppBar, Box, InputLabel, Typography } from '@mui/material';
import { images } from '~/assets';
import { Button } from '@mui/material';

import { useNavigate } from 'react-router-dom';
import { adminRouteAbsolute } from '~/utils/constants/route';
import { useAppDispatch, useAppSelector } from '~/redux/hooks';
import { IForgotPassword } from '~/utils/interface/auth';
import { useFormik } from 'formik';
import { cast, handleApiError } from '~/utils/helper';
import { useTranslation } from 'react-i18next';
import BaseSelect from '~/components/common/base-select/BaseSelect';
import { SelectOption } from '~/utils/types/franchise';
import { useEffect, useState } from 'react';
import { handleGetSelectionCompanies } from '~/thunks/company/companyThunk';
import ModalAlertLogout from '~/components/common/modal-alert-logout/ModalAlertLogout';
import { StorageEnum } from '~/utils/enum';

const cx = classNames.bind(styles);

const initialValues: IForgotPassword = {
  email: '',
};

const SelectFranchise = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation(['admin/franchise', 'admin/layout', 'admin/auth']);
  const navigate = useNavigate();
  const [value, setValue] = useState<string>();

  const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false);
  //#endregion Declare State

  //#region Implement Hook

  const { companies } = useAppSelector((state) => state.company);

  const form = useFormik({
    initialValues,
    onSubmit: async (values, { setFieldError }) => {
      try {
        navigate(`${adminRouteAbsolute.dashboard}`);
      } catch (e) {
        handleApiError(e, setFieldError);
      }
    },
  });

  const renderFranchiseComponent = (item: SelectOption) => {
    return <Box className={cx('franchise')}>{item.name}</Box>;
  };
  const handleOpenModalLogOut = () => {
    setIsDialogOpen(true);
  };
  const handleCancelLogOut = () => {
    setIsDialogOpen(false);
  };
  const handleConfirmLogOut = () => {
    localStorage.removeItem(StorageEnum.ACCESS_TOKEN);
    localStorage.removeItem(StorageEnum.REFRESH_TOKEN);
    localStorage.removeItem(StorageEnum.COMPANY_ID);
    window.location.href = '/admin/login';
    setIsDialogOpen(false);
  };
  const handleSelectFranchise = (id: string) => {
    localStorage.setItem('companyId', id);
    setValue(id);
  };
  const renderSelectedFranchiseComponent = (item: SelectOption) => {
    return <Box className={cx('franchise')}>{item.name}</Box>;
  };
  useEffect(() => {
    if (dispatch) {
      dispatch(handleGetSelectionCompanies());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Box className={cx('w-full', 'h-full')}>
      <AppBar
        color='inherit'
        className={cx('px-4 md:px-20 py-2.5 border-b border-[#E5EAEF]')}
        elevation={0}
        position='relative'
      >
        <Box className={cx('flex justify-between items-center')}>
          <img src={images.logo} alt='' className={cx('w-[61px] h-[62px]')} />
          <Box className='flex flex-row gap-[16px] h-[38px]'>
            <Box className='flex items-center'>
              <Button className=' text-base' onClick={() => handleOpenModalLogOut()}>
                {t('header.logOut', { ns: 'admin/layout' })}
              </Button>
              <ModalAlertLogout open={isDialogOpen} onCancel={handleCancelLogOut} onConfirm={handleConfirmLogOut} />
            </Box>
          </Box>
        </Box>
      </AppBar>
      <Box component='section' className={cx('w-full h-full flex justify-center items-center fixed z-20 ')}>
        <Box
          component='form'
          onSubmit={form.handleSubmit}
          className={cx('max-w-[500px] w-full px-4 sm:px-0 mt-[-200px]')}
        >
          <Box>
            <Box className={cx('text-center gap-5')}>
              <img src={images.logo} alt='' className={cx('w-[60px] h-[60px] inline-block')} />
              <Box className={cx('mt-5')}>
                <Typography className={cx('!font-medium !text-black !text-4xl !leading-[43.2px]')} variant='h2'>
                  {t('selectFranchise')}
                </Typography>
                <Typography
                  variant='body1'
                  className={cx('!font-normal !text-base !leading-[19.2px] !text-[#86929D] !mt-2.5')}
                >
                  {t('selectFranchiseToContinue')}
                </Typography>
              </Box>
            </Box>
            <Box className={cx('sm:mt-[60px] mt-6')}>
              <Box>
                <InputLabel className={cx('!text-[12px] text-[#323953] !font-normal !leading-[14.4px]')}>
                  {t('franchise')}
                </InputLabel>
                <BaseSelect
                  onChange={(e) => handleSelectFranchise(e.target.value)}
                  value={cast(value)}
                  label='Select a Franchise'
                  menuClassName={cx('select-franchise-menu')}
                  options={companies}
                  renderSelected={(item: SelectOption) => renderSelectedFranchiseComponent(item)}
                  renderOptionItem={(item: SelectOption) => renderFranchiseComponent(item)}
                  isSearchEnable={true}
                />
              </Box>
            </Box>
          </Box>
          <Box className={cx('mt-[30px]')}>
            <Button
              type='submit'
              variant='contained'
              color='primary'
              disabled={!value}
              sx={{
                boxShadow: 'none',
                '&:hover': {
                  boxShadow: 'none',
                },
              }}
              className={'w-full !rounded-lg h-9 leading-[16.8px]'}
            >
              {t('continue')}
            </Button>
          </Box>
        </Box>
      </Box>
      <Box
        className={cx(
          'w-full',
          'h-[40%]',
          'background-bottom',
          'fixed',
          'bottom-0',
          'bg-cover',
          'bg-center',
          'opacity-[0.02]'
        )}
      ></Box>
    </Box>
  );
};

export default SelectFranchise;
